import React from 'react';
import { Plus as PlusIcon, Minus as MinusIcon } from 'react-feather';
import { IconButton, Typography } from 'ui-kit';
import 'components/Store/ProductCardStore/ProductCardStore.scss';

interface IProductAddButton {
  amount: number;
  onAdd: () => void;
  onSubstract: () => void;
  initialShow: boolean;
  outOfStock: boolean;
}

const ProductAddButton = ({ amount, onSubstract, onAdd, outOfStock }: IProductAddButton) => {
  return (
    <div className="ProductCardStore-actions">
      <IconButton
        variant="outlined"
        color="textGray"
        size="small"
        onClick={onSubstract}
        disabled={amount === 1}
      >
        <MinusIcon />
      </IconButton>
      <Typography variant="body1" className="ProductCardStore-actions__amountValue">
        {amount}
      </Typography>
      {!outOfStock && (
        <IconButton color="textGray" variant="outlined" size="small" onClick={onAdd}>
          <PlusIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ProductAddButton;
